<template>
  <div class="TagAttribute">
    <div class="titleBox">
      <el-page-header @back="goBack" :content="content"></el-page-header>
    </div>
    <AppBox class="appBox" id="appBox">
      <div class="toolsBox">
        <el-button type="primary" plain @click="handleAddTagAttribute"
                   v-show="permissionCode.has('research:tag:manager')"
        >新增标签分类
        </el-button>
      </div>
      <AttributeList :maxHeight="maxHeight"></AttributeList>
    </AppBox>
  </div>
</template>

<script>
import AppBox from "@/components/ui/AppBox/index.vue";
import AttributeList from "@/pages/TagManagement/AttributeList.vue";
import {mapMutations, mapState} from "vuex";

export default {
  name: "TagAttribute",
  components: {AttributeList, AppBox},
  data() {
    return {
      content: "标签管理 | 标签分类管理",
      maxHeight: null,
    };
  },
  mounted() {
    this.handleResize();
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize); // 移除resize事件监听
  },
  computed: {
    ...mapState("user", ["permissionCode"]),
    columns: function () {

    },
  },
  methods: {
    ...mapMutations("teachingCenter", ["setData"]),
    // 添加属性弹框
    handleAddTagAttribute() {
      this.setData({
        key: "rowDetails",
        value: {},
      });
      this.setData({
        key: "addTagAttributeVisible",
        value: true,
      });
    },
    async goBack() {
      this.setData({key: "isBack", value: true});
      this.$router.go(-1);
    },
    // 重置高度
    handleResize() {
      this.$nextTick(() => {
        const el = document.getElementById("appBox");
        if (el.offsetHeight <= 650) {
          this.maxHeight = el.offsetHeight - el.offsetHeight * 0.4;
        } else {
          this.maxHeight = el.offsetHeight - el.offsetHeight * 0.25;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../styles/variables";

.TagAttribute {
  .titleBox {
    background: white;
    border-radius: 2px;
    padding: 20px;
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    ::v-deep .el-page-header__left {
      color: map-get($colors, primary);
    }
  }

  .appBox {
    height: calc(100vh - 155px);
    min-height: 350px;

    .toolsBox {
      text-align: right;
      margin-bottom: 20px;
    }
  }

  ::v-deep .el-dialog {
    margin-top: 30vh !important;
    width: 500px;
  }

  ::v-deep .el-dialog .el-dialog__body {
    padding: 20px 40px;
  }
}
</style>
